import React from 'react';
import styled from 'styled-components';

const HomeContainer = styled.div`
  min-height: 100vh;
  padding: 6rem 2rem 2rem;
`;

const Hero = styled.section`
  text-align: center;
  margin-bottom: 4rem;
`;

const Title = styled.h1`
  font-size: 3rem;
  margin-bottom: 1rem;
  color: #333;
`;

const Subtitle = styled.p`
  font-size: 1.2rem;
  color: #666;
  max-width: 600px;
  margin: 0 auto;
`;

const Home = () => {
  return (
    <HomeContainer>
      <Hero>
        <Title>Welcome to My Personal Space</Title>
        <Subtitle>
          Explore my professional journey, read my thoughts, enjoy my poetry, and watch my curated videos.
        </Subtitle>
      </Hero>
    </HomeContainer>
  );
};

export default Home;
